// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SavedMessagesProfile__divider-background-cb4773 {
  width: 100%;
  height: 12px;
  background-color: var(--base-15);
  margin: 10px 0;
  border: none;
}

.SavedMessagesProfile__list-item-b90844 {
  min-height: 48px;
  padding: 0 var(--padding);
}

.SavedMessagesProfile__list-icon-dd60ee {
  fill: var(--base-80);
}`, "",{"version":3,"sources":["webpack://./src/main/Profile/SavedMessagesProfile/SavedMessagesProfile.styles.m.css"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;EACA,gCAAA;EACA,cAAA;EACA,YAAA;AACF;;AAEA;EACE,gBAAA;EACA,yBAAA;AACF;;AAEA;EACE,oBAAA;AACF","sourcesContent":[".divider-background {\n  width: 100%;\n  height: 12px;\n  background-color: var(--base-15);\n  margin: 10px 0;\n  border: none;\n}\n\n.list-item {\n  min-height: 48px;\n  padding: 0 var(--padding);\n}\n\n.list-icon {\n  fill: var(--base-80);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"divider-background": `SavedMessagesProfile__divider-background-cb4773`,
	"dividerBackground": `SavedMessagesProfile__divider-background-cb4773`,
	"list-item": `SavedMessagesProfile__list-item-b90844`,
	"listItem": `SavedMessagesProfile__list-item-b90844`,
	"list-icon": `SavedMessagesProfile__list-icon-dd60ee`,
	"listIcon": `SavedMessagesProfile__list-icon-dd60ee`
};
module.exports = ___CSS_LOADER_EXPORT___;
